var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2482_23177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.452 3.8253L13.2921 5.97106L11.452 3.8253ZM12.6353 1.93497L7.65977 7.73977C7.40269 8.03928 7.22736 8.42088 7.15588 8.83647L6.69629 11.5204L8.99684 10.9832C9.35304 10.9001 9.6797 10.6964 9.93686 10.3964L14.9124 4.59157C15.0619 4.41714 15.1805 4.21005 15.2614 3.98214C15.3424 3.75423 15.384 3.50996 15.384 3.26327C15.384 3.01658 15.3424 2.77231 15.2614 2.5444C15.1805 2.31649 15.0619 2.1094 14.9124 1.93497C14.7629 1.76053 14.5854 1.62216 14.39 1.52776C14.1947 1.43335 13.9853 1.38477 13.7739 1.38477C13.5624 1.38477 13.353 1.43335 13.1577 1.52776C12.9623 1.62216 12.7848 1.76053 12.6353 1.93497V1.93497Z",
    stroke: "#516975",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.647 13.548V16.5887C13.647 17.1264 13.464 17.642 13.1381 18.0221C12.8123 18.4023 12.3703 18.6159 11.9095 18.6159H2.35281C1.89198 18.6159 1.45002 18.4023 1.12416 18.0221C0.7983 17.642 0.615234 17.1264 0.615234 16.5887V5.43928C0.615234 4.90164 0.7983 4.38602 1.12416 4.00585C1.45002 3.62569 1.89198 3.41211 2.35281 3.41211H4.95917",
    stroke: "#516975",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2482_23177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 18.6667,
    fill: "white",
    transform: "translate(0 0.666016)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a89cab2c106502193da395953ecdc00a.svg";
export { ForwardRef as ReactComponent };